
export class ServiceConst {
    public static readonly LOGIN = 'LoginService';
    public static readonly RECUPERA_SENHA = 'RecuperaSenhaService';
    public static readonly CADASTRAO = 'CadastraoService';
    public static readonly FILIAL = 'FilialService';
    public static readonly FORNECEDOR = 'FornecedorService';
    public static readonly COTACAO = 'CotacaoService';
    public static readonly ITENS_COTACAO = 'ItensCotacaoService';
    public static readonly PARAMETRO = 'ParametroService';
    public static readonly PEDIDO = 'PedidoService';
    public static readonly MERCADO = 'MercadoService';
    public static readonly MERC_FORN_VEND = 'MercFornVendService';
    public static readonly USUARIO = 'UsuarioService';
    public static readonly VENDEDOR = 'VendedorService';
    public static readonly LOG = 'LogService';

}